import SeoHead from '../components/SeoHead';
import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import SubBanner from '../components/SubBanner';
import SimplePage from '../components/SimplePage';
import Header from '../components/MainHeader';

export default function simplePage({
    page
}) {
    return (
        <>
            <Header />
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${page.title} | Gap Personnel`}
                // description={``}
                canonical_link={`/${page.url_slug}/`}
            />
            <SubBanner
                global={global}
                pathPrefix={`${page.url_slug}_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`${page.title}`}
            />
            <SimplePage
                global={global}
                pathPrefix={`${page.url_slug}_page.content`}
                page={page}
                customClass={`simple-page`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const page = (await Collection('simple_pages')).getJsonItem(params.url_slug, 'url_slug');
    return {
        props: { page },
    }
}

export async function getStaticPaths() {
    const pagePaths = (await Collection('simple_pages')).getPaths('url_slug');
    return {
        paths: pagePaths,
        fallback: false
    }
}